import React, { useState, useEffect } from 'react';
import { useAuth } from '../AuthProvider';
import { get } from '../../api';

const enc = encodeURIComponent;

const Root = (props) => {
  const [agentId, setAgentId] = useState(null);
  const auth = useAuth();

  useEffect(() => {
    if (auth && auth.userData) {
      if (agentId == null) {
        const getAgentIdByPersonaId = async (personaId) =>
          await get({
            api: `api/budget/find/agent?personaId=${enc(personaId)}`,
          });
        getAgentIdByPersonaId(auth.userData.profile.persona_id).then((result) => {
          setAgentId(result.agentId);
        }).catch(() => {
          alert('Se ha producido un error, inténtelo más tarde.');
        })
      }
    }
    return;
  }, [auth]);

  if (agentId) {
    return props.children(agentId);
  } else {
    return <div>Autenticando</div>;
  }
};

export default Root;



// WEBPACK FOOTER //
// ./src/components/Root/index.js